import React, { useEffect, useState } from 'react';
import Pagination from '@mui/material/Pagination';
import { TransparenciaService } from '@services/transparencia';
import Stack from '@mui/material/Stack';
import { LoadingIndicator } from '@components';

export const ListaFornecedores = () => {
  const [page, setPage] = useState(1);
  const [dados, setDados] = useState();
  const [loading, setLoading] = useState(true);
  const [filtroFornecedores, setFiltroFornecedores] = useState();

  const handleChange = (event, value) => {
    setPage(value);
    setFiltroFornecedores(
      dados !== undefined &&
        dados.filter((item) => {
          return item.Pagina === value;
        })
    );
  };

  useEffect(() => {
    const recuperaFornecedores = async () => {
      const transparenciaService = new TransparenciaService();
      const responseFornecedores = await transparenciaService.getFornecedores();
      setDados(responseFornecedores);
      setFiltroFornecedores(
        responseFornecedores.filter((item) => {
          return item.Pagina === 1;
        })
      );
      setLoading(false);
    };

    recuperaFornecedores();
  }, []);

  return !loading ? (
    <div className="row">
      <div className="d-flex flex-row d-md-block mt-4 mb-4 align-items-center">
        <Stack spacing={2}>
          <Pagination
            count={dados[dados.length - 1].Pagina}
            page={page}
            onChange={handleChange}
          />
        </Stack>
      </div>
      {filtroFornecedores.map((item) => (
        <div
          className="col-12 col-lg-6 col-xl-3 mb-4"
          key={item.nome + item.CNPJ}
        >
          <div className="card h-100">
            <div className="card-body">
              <h3 className="fw-bold ts-20">{item.Fornecedor}</h3>
              <h5 className="ts-14">{item.CNPJ}</h5>
            </div>
            <div className="card-footer">
              <p className="ts-14 text-muted">{item.Servico}</p>
            </div>
          </div>
        </div>
      ))}
    </div>
  ) : (
    <LoadingIndicator />
  );
};
